import Backend from './index';

const backend = new Backend();

export const get2ankiApi = () => backend;
